export const SITE_NAME = 'Borsaya.com'
export const SITE_URL = 'https://www.borsaya.com'
export const API_URL = process.env.NEXT_PUBLIC_API_URL || ''

export const OG_IMAGE = {
  url: `${SITE_URL}/opengraph-image`,
  width: 1200,
  height: 630,
  alt: SITE_NAME,
}
